import riderGlbUrl from "../../assets/glb/rider.glb?url";
import treeGlbUrl from "../../assets/glb/tree.glb?url";
import groomedSnowUrl from "../../assets/img/groomed_snow.png?url";
import powderSnowUrl from "../../assets/img/powder_snow.png?url";
import panoramaUrl from "../../assets/img/panorama.png?url";

export const assets = {
  riderGlb: riderGlbUrl,
  treeGlb: treeGlbUrl,
  groomedSnow: groomedSnowUrl,
  powderSnow: powderSnowUrl,
  panorama: panoramaUrl
} as const;
